import { REPRESENTATIVE_PAGE_SIZE } from "./representative-helpers";

export function appendPaginationParams(params, page, pageSize = REPRESENTATIVE_PAGE_SIZE) {
  params.set("page", String(page ?? 0));
  params.set("pageSize", String(pageSize));
  return params;
}

export function appendCommonFilterParams(params, filters) {
  const status = filters?.status?.value ?? filters?.status?.id;
  if (status && status !== "TODOS") {
    params.set("status", String(status).toUpperCase());
  }

  const estado = filters?.region?.value;
  if (estado) {
    params.set("estado", String(estado).toUpperCase());
  }

  if (filters?.grupoEconomico?.Id != null) {
    params.set("idGrupoEconomico", String(filters.grupoEconomico.Id));
  }

  if (filters?.razaoSocial?.Id != null) {
    params.set("idPessoaLoja", String(filters.razaoSocial.Id));
  }

  const cnpjDigits = (filters?.cnpj || "").replace(/\D/g, "");
  if (cnpjDigits) {
    params.set("cnpj", cnpjDigits);
  }

  const nome = filters?.search?.trim();
  if (nome) {
    params.set("nome", nome);
  }

  return params;
}

export function buildRepresentativePagedQuery(filters, { idMarca, page, pageSize }) {
  const params = new URLSearchParams();
  if (idMarca != null) {
    params.set("idMarca", String(idMarca));
  }
  appendCommonFilterParams(params, filters);
  appendPaginationParams(params, page, pageSize);
  return params.toString();
}

export function buildClientePagedQuery(filters, { idVitrineVirtualB2b, page, pageSize }) {
  const params = new URLSearchParams();
  if (idVitrineVirtualB2b != null) {
    params.set("idVitrineVirtualB2b", String(idVitrineVirtualB2b));
  }
  appendCommonFilterParams(params, filters);
  appendPaginationParams(params, page, pageSize);
  return params.toString();
}
